/**
 * A session is bookable when it is active and one-on-one — the same rule the
 * professional and project detail pages apply to their Book a Meeting rows.
 */
const isBookableSession = <
    T extends { IsActive?: boolean | null; MeetingType?: string | null },
>(
    session: T | null | undefined,
): session is T =>
    Boolean(session?.IsActive && session.MeetingType === 'one-on-one');

/**
 * Decides whether the Specification Representative section surfaces its Book a
 * Meeting entry point, returning the session to book against or null when the
 * CTA must not render.
 *
 * Bookability follows the platform rule (active, one-on-one Client Director
 * session), and the entry point additionally sits behind the
 * `book_meeting_open_access` feature flag, the single switch all revamp
 * booking surfaces ship behind. With the flag off or nothing bookable the
 * section renders exactly as it does today (Call / Send Message only).
 */
export const resolveSpecRepBookingSession = <
    T extends { IsActive?: boolean | null; MeetingType?: string | null },
>(
    session: T | null | undefined,
    openAccessEnabled: boolean,
): T | null =>
    openAccessEnabled && isBookableSession(session) ? session : null;
